import type { BuilderTypeToReducedManifest, BuilderTypeToPresetInfo } from '@wix/thunderbolt-becky-types'

export const calculateBuilderTypeToPresetInfo = ({
	rootBuilderType,
	descendantBuilderTypes,
	builderTypeToReducedManifest
}: {
	rootBuilderType: string
	descendantBuilderTypes: string[]
	builderTypeToReducedManifest: BuilderTypeToReducedManifest
}) => {
	const builderTypeToPresetInfo: BuilderTypeToPresetInfo = {}
	const allBuilderTypesPerWidget = new Set<string>([rootBuilderType, ...descendantBuilderTypes])

	// todo: add innerElements: Record<key, selector>
	allBuilderTypesPerWidget.forEach((descendantBuilderType) => {
		if (builderTypeToPresetInfo[descendantBuilderType]) {
			return
		}
		const manifest = builderTypeToReducedManifest[descendantBuilderType]
		if (!manifest) {
			return
		}
		const { root, ...childElementsData } = manifest.elementData
		const shouldCreatePresetInfoEntry = (root.presetVariableKey && root.presets) || Object.keys(childElementsData).length > 0
		if (!shouldCreatePresetInfoEntry) {
			return
		}
		// init entry
		builderTypeToPresetInfo[descendantBuilderType] = {}

		// save preset hashes
		if (root.presetVariableKey && root.presets) {
			const presetHashes: Record<string, string> = {}
			for (const presetKey in root.presets) {
				presetHashes[presetKey] = root.presets[presetKey].customCssKey!
			}
			builderTypeToPresetInfo[descendantBuilderType].presetVariableKey = root.presetVariableKey
			builderTypeToPresetInfo[descendantBuilderType].presetHashes = presetHashes
		}
		// save inner elements selectors
		// as an optimization, save only selectors till the first ref element
		const rootSelector = root.selector
		const innerElementsSelectors: Record<string, string> = {}

		for (const elementKey in childElementsData) {
			// removing root selector part from the inner element selector
			innerElementsSelectors[elementKey] = childElementsData[elementKey].selector.replace(`${rootSelector} `, '')
		}
		if (Object.keys(innerElementsSelectors).length) {
			builderTypeToPresetInfo[descendantBuilderType].innerElementsSelectors = innerElementsSelectors
		}
	})

	return builderTypeToPresetInfo
}
